export const SERVICE_MANAGEMENT_SETTINGS_KEY = "inform-management-web";
